


















import { QuestionBase } from './QuestionBase';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { mapGetters } from 'vuex';
import { Topic } from '@/models/topic';
import { Configuration } from '@/models/configuration';

@Component({
})

export default class QuestionsMobile extends QuestionBase {

    @Getter('topic/activeTopic') private activeTopic: Topic;
    @Getter('configuration/configuration') private configuration: Configuration;

    // Data
    private isMobileScreen: boolean = false;

    private goNextTopic() {
        const currentTopicIndex = this.activeTopic.id - 1;
        this.$store.commit('topic/setActiveTopic', this.topics[currentTopicIndex + 1]);
    }

    private goPreviousTopic() {
        const currentTopicIndex = this.activeTopic.id - 1;
        this.$store.commit('topic/setActiveTopic', this.topics[currentTopicIndex - 1]);
    }
}
